import React from 'react';

import { useCustomPermission, useCustomPermissionRegistrationCheck } from 'providers/Access.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

const Permitted = ({ children, placeholder, not, value, tag: tagFromProps }) => {
  const tag = fromAnyToTrimmed(tagFromProps);

  useCustomPermissionRegistrationCheck(value, tag);
  const isPermitted = useCustomPermission(value);

  if (placeholder) return <>{children}</>;

  // just an extra variable to hold the same value or in the case of `not` property, be the inverse
  const isPermittedAfterNegation = not ? !isPermitted : isPermitted;

  return isPermittedAfterNegation ? <>{children}</> : null;
};

export default Permitted;
